module.exports = require("swa-bootstrap-corporate-landing-home-page/air/fare-data");